<template>
  <div class="app">
    <myheader></myheader>
    <div class="header-bj w-100 h-100 wow bounceInUp pc">
      <el-carousel indicator-position="outside" :height="bannerHeight+'px'">
          <el-carousel-item v-for="(item,index) in bannerImg.imgList" :key="index">
            <img
              ref="bannerHeight"
              @load="imgLoad"
              class="w-100"
              :src="`http://www.waternaida.com/${item.image}`"
              alt
            />
          </el-carousel-item>
        </el-carousel>
    </div>
    <div class="mb">
        <img class="w-100 mb" src="../../static/img/mb_banner.png" alt />
    </div>
    <div class="main">
      <div class="main_header w-100 wow fadeIn">
        <div class="main_header_txt w-100 fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">
          <span
            class="main_txt1 w-100 fadeInUp"
            data-wow-duration="1s"
            data-wow-delay="0.5s"
          >NUESTROS PRODUCTOS</span>
          <span
            class="main_txt2 w-100"
          >Fabricamos  todos los equipos y repuestos de ósmosis inversa domésticos y comerciales.</span>
        </div>
        <div>
          <img class="main_header_img" src="../img/index_water.png" alt />
        </div>
      </div>
      <div class="main_xq row wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">
        <div class="main_item col-lg-3 col-md-6 col-sm-6 col-xs-12" v-for="(item,index) in product.proList" :key="index">
          <div class="main_item_img w-100">
            <router-link :to="{path:'/product_item_ESP',query:{id:item.id}}" class="main_item_txt_3"><img class="w-100 h-100" :src="`http://www.waternaida.com/${item.image}`" alt /></router-link>
          </div>
          <div class="main_item_txt">
            <span class="main_item_txt_header">{{item.name}}</span>
            <img src="../../static/img/矩形.png" alt />
            <span class="main_item_txt_2" v-html="item.miao_content"></span>
            <router-link
              :to="{path:'/product_item_ESP',query:{id:item.id}}"
              class="main_item_txt_3"
            >Ver detalles</router-link>
          </div>
        </div>
      </div>
      <div class="main_product row">
        <!-- <div class="col-lg-6 col-md-12 col-sm-12"></div> -->
        <div class="pro_noise">
            <div class="main_product_txt col-lg-6 col-md-12 col-sm-12">
                <div class="main_product_t">
                    <div class="main_product_txt">
                    <span
                        class="product1 wow fadeInUp"
                        data-wow-duration="1s"
                        data-wow-delay="0.5s"
                    >Ventajas de los productos</span>
                    <span
                        class="product2 wow fadeInUp"
                        data-wow-duration="1s"
                        data-wow-delay="0.5s"
                    >APROBACIÓN DE NSF,FDA,WQA,CE,EU,ROHS,ISO 9001</span>
                    <!-- <span
                        class="product3 wow fadeInUp"
                        data-wow-duration="1s"
                        data-wow-delay="0.5s"
                    >Produce 50/75/100 galones de agua por día. Nuestro sistema principal</span> -->
                    </div>
                    <div class="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">
                    <div class="product_noise" style="width:50%;float:left; display:flex;">
                        <div style="width:12%;margin-top:5px;">
                        <img src="../../static/img/nosound1.png" alt />
                        </div>
                        <div style="float: left;width:88%;">
                        <span class="product_noise_txt_span tit">Diseño elegante del sistema O.I.</span>
                        <span class="product_noise_txt_span">Recordatorio de valor TDS y reemplazo del cartucho del filtro.Control de pantalla táctil LCD</span>
                        </div>
                    </div>
                    <div class="product_noise" style="width:50%;float:left; display:flex;">
                        <div style="width:12%;margin-top:5px;">
                        <img src="../../static/img/nosound2.png" alt />
                        </div>
                        <div style="float: left;width:88%;">
                        <span class="product_noise_txt_span tit">Buen rendimiento</span>
                        <span class="product_noise_txt_span">Gran caudal, no necesita tanque.Hacer agua fresca al instante.Sin contaminación secundaria</span>
                        </div>
                    </div>
                    <div class="product_noise" style="width:50%;float:left; display:flex;">
                        <div style="width:12%;margin-top:5px;">
                        <img src="../../static/img/nosound3.png" alt />
                        </div>
                        <div style="float: left;width:88%;">
                        <span class="product_noise_txt_span tit">Inteligente y seguro</span>
                        <span class="product_noise_txt_span">Sistema integrado de filtro de agua.Ahorre espacio en un 60% y reduzca el riesgo de fugas en un 99%</span>
                        </div>
                    </div>
                    <div class="product_noise" style="width:50%;float:left; display:flex;">
                        <div style="width:12%;margin-top:5px;">
                        <img src="../../static/img/nosound4.png" alt />
                        </div>
                        <div style="float: left;width:88%;">
                        <span class="product_noise_txt_span tit">Económico y ahorro de agua</span>
                        <span class="product_noise_txt_span">Regulación dinámica de agua pura y aguas residuales.Proporción 1.5: 1 de agua pura a agua de drenaje</span>
                        </div>
                    </div>
                    <div class="product_noise" style="width:50%;float:left; display:flex;">
                        <div style="width:12%;margin-top:5px;">
                        <img src="../../static/img/nosound5.png" alt />
                        </div>
                        <div style="float: left;width:88%;">
                        <span class="product_noise_txt_span tit">Más silencioso con menos ruido</span>
                        <span class="product_noise_txt_span">Doble absorción de impactos con bajos dB</span>
                        </div>
                    </div>
                    <div class="product_noise" style="width:50%;float:left; display:flex;">
                        <div style="width:12%;margin-top:5px;">
                        <img src="../../static/img/nosound6.png" alt />
                        </div>
                        <div style="float: left;width:88%;">
                        <span class="product_noise_txt_span tit">Mantenimiento seguro y fácil</span>
                        <span class="product_noise_txt_span">Filtro múltiple integrado.Doble bloqueo automático, mantenimiento seguro y fácil</span>
                        </div>
                    </div>
                    </div>
                    <div class="w-100 d-block text-left">
                    <el-button @click="SeeMore1"
                        class="mt-1 wow fadeInUp"
                        type="success"
                        data-wow-duration="1s"
                        data-wow-delay="0.5s"
                    >VER MÁS</el-button>
                    </div>
                </div>
                </div>
        </div>
      </div>
      <div class="main_footer row">
        <div class="main_footer_item col-lg-4 col-md-12 col-sm-12 wow bounceInLeft">
          <span class="main_footer_txt1">El taller</span>
          <!-- <span
            class="main_footer_txt2"
          >Somos un fabricante de purificadores de agua de producción propia.</span>
          <span
            class="main_footer_txt3"
          >Produce 50/75/100 galones de agua por día. Nuestro sistema principal</span> -->
          <span class="main_footer_txt4">
            <img class="mr-1" src="../img/li.png" alt />La materia prima y los productos terminados son estrictamente probados por QC.
          </span>
          <span class="main_footer_txt4">
            <img class="mr-1" src="../img/li.png" alt />Las máquinas de inyección semiautomáticas se utilizan para mantener la capacidad de producción.
          </span>
          <span class="main_footer_txt4">
            <img class="mr-1" src="../img/li.png" alt />El departamento de marketing propone el desarrollo de nuevos productos y el departamento técnico estudia y desarrolla nuevos productos por año.
          </span>
          <span class="main_footer_txt4">
            <img class="mr-1" src="../img/li.png" alt />OEM y ODM son bienvenidos.
          </span>
          <span class="main_footer_txt4">
            <img class="mr-1" src="../img/li.png" alt />Cada vez más agentes y socios se unen a nosotros para compartir el modelo de ganar-ganar del mercado y avanzar juntos.
          </span>
          <el-button @click="SeeMore2" class="main_footer_btn" type="success">VER MÁS</el-button>
        </div>
        <div class="main_footer_item col-lg-4 col-md-12 col-sm-12 wow bounceInRight">
          <img @click="SeeMoreImg" style="cursor:pointer;" title="Nuestra fábrica" class src="../img/index_main_footer.png" alt />
          <a href="javascript:;" @click="SeeMoreImg">VER MÁS</a>
        </div>
        <div class="main_footer_item col-lg-4 col-md-12 col-sm-12 wow bounceInRight">
          <img @click="SeeMoreImg" style="cursor:pointer;" title="Nuestra fábrica" class src="../img/index_main_footer2.png" alt />
          <a href="javascript:;" @click="SeeMoreImg">VER MÁS</a>
        </div>
      </div>
    </div>
    <myfooter></myfooter>
  </div>
</template>
<style scoped>
body {
  background-color: #fefefe;
  width: 100%;
}
html body #app .header .main {
  width: 100%;
}
.navActive {
  position: fixed;
  background-color: #0269b6c2;
}
#app {
  width: 100%;
  height: 100%;
}
.row {
  margin-left: 0;
}
.main_item_txt_header {
  font-size: 1.25rem;
}
.main_item_txt_2 {
  font-size: 0.75rem;
  margin-top: 1%;
}
.main_item_txt_3 {
  font-size: 1.25rem;
  color: #009944;
}
.main_item_txt_3 {
  text-decoration: none;
}
@media screen and (max-width: 1400px){
    .product_noise > div{
        margin-right: 5px;
    }
}
@media screen and (min-width: 1200px) {
  .header-bj {
    margin-top: -100px;
  }
  #aboutus {
    position: fixed;
    z-index: 1000;
    background-color: white;
    width: 100%;
    color: gray;
    top: 100px;
  }
  .about_main {
    width: 80%;
    font-size: 18px;
    margin: 0 auto;
    text-align: left;
  }
  .about_item {
    padding-top: 30px;
  }
  .about_item > a {
    color: gray;
    text-decoration: none;
  }
  .about_item > a:hover {
    color: #3084c7;
  }
  .main_product_txt > div > div > span {
    display: block;
    text-align: left;
  }
  .header_icon {
    display: none;
    z-index: 5;
  }
  .header {
    width: 100%;
    /* height: 1000px; */
    overflow: hidden;
  }
  body > .el-dropdown-menu {
    width: 100% !important;
  }
  .header_nav {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    margin: 0 auto;
    display: flex;
    z-index: 999;
  }
  .nav {
    margin: 0 auto;
    z-index: 999;
    width: 100%;
    overflow: hidden;
  }
  .nav-item {
    margin-right: 4%;
    height: 100px;
    padding: 0;
    z-index: 999;
    color: #fff;
  }
  .nav-item a a {
    text-decoration: none;
  }
  .nav-item a a:hover {
    text-decoration: none;
  }
  .nav-link {
    padding: 0;
    z-index: 999;
    color: #fff;
    text-decoration: none;
  }
  .nav-link:hover {
    text-decoration: none;
  }
  .nav-link a {
    text-decoration: none;
    color: #fff;
  }
  .log {
    margin-top: 0;
  }
  .logo_img {
    /* background-color: red; */
    z-index: 999;
    width: 20%;
    margin-left: 4%;
  }
}
@media screen and (max-width: 1199px) {
  body {
    width: 100%;
  }
  #app {
    width: 100%;
    height: 100%;
  }
  .main_footer_item {
    margin-bottom: 15px;
  }
  .logo_img {
    width: 90%;
    height: 100%;
  }
  .main_product_txt {
    width: 100%;
    text-align: center;
    /* background-color: lightcoral; */
    padding-right: 0;
  }
  .header_nav > ul {
    display: none;
    z-index: 999;
  }
  .header_icon {
    display: inline;
    z-index: 5;
  }
  .header-bj {
    margin-top: 0px;
  }
  .header {
    width: 100%;
    /* height: 1000px; */
  }
  .header_nav {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    margin: 0 auto;
    display: flex;
    z-index: 999;
  }
  .nav {
    width: 100%;
    margin: 0 auto;
    z-index: 999;
    overflow: hidden;
  }
  .nav-item {
    margin-right: 60px;
    height: 100px;
    padding: 0;
    z-index: 999;
    color: #fff;
  }
  .nav-item div a {
    text-decoration: none;
  }
  .nav-link {
    padding: 0;
    z-index: 999;
    color: #fff;
    text-decoration: none;
  }
  .log {
    margin-top: 0;
  }
  .logo_img {
    /* background-color: red; */
    z-index: 2;
    width: 50%;
    display: none;
  }
  .header_icon {
    width: 100%;
    text-align: right;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #ffffff;
    font-size: 28px;
  }
  .el-icon-arrow-down {
    font-size: 18px;
    text-align: center;
  }
  .el-item-size {
    font-size: 18px;
    text-align: center;
  }
  .main_txt1 {
    font-size: 16px;
    color: #0168b7;
    display: block;
    width: 100%;
    /* background-color: khaki; */
  }
  .main_txt2 {
    font-size: 14px;
    color: #868585;
    display: block;
    width: 100%;
  }
  .main_header_txt {
    /* background-color: lawngreen; */
    width: 100%;
  }
  .main_header_txt > span {
    display: block;
    margin: 0 auto;
    text-align: center;
    width: 100%;
  }
  .main_header_img {
    /* background-color: brown; */
    margin: 0 auto;
    width: 100%;
    text-align: center;
    display: block;
    padding-top: 130px;
    /* background-color: lightblue; */
  }
  .product_noise > div > img {
    display: none;
  }
}
@media screen and (max-width: 576px) {
  .main_item_txt > span {
    display: block;
    margin-bottom: 10px;
  }
  .main_item {
    width: 100%;
    /* background-color: tan; */
    margin-bottom: 60px;
    display: block;
    -webkit-box-flex: 0;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .main_item_img {
    margin-bottom: 10px;
    width: 100%;
  }
  .main_item:hover {
    background-color: #ffffff;
    box-shadow: 0px 10px 15px #888888;
  }
}
.main_footer_btn {
  background-color: #009944;
  display: block;
  text-align: left;
  margin-top: 20px;
}
.main_footer_txt1 {
  display: block;
  font-size: 40px;
  color: #0168b7;
  text-align: left;
}
.main_footer_txt2 {
  display: block;
  font-size: 16px;
  color: #000;
  text-align: left;
  margin-bottom: 15px;
}
.main_footer_txt3 {
  display: block;
  font-size: 16px;
  color: gray;
  text-align: left;
  margin-bottom: 18px;
}
.main_footer_txt4 {
  display: block;
  font-size: 18px;
  color: #000;
  text-align: left;
  margin-bottom: 10px;
}
.main_footer_txt5 {
  display: block;
  font-size: 18px;
  color: #000;
  text-align: left;
}
.main_footer {
  /* background-color: saddlebrown; */
  width: 80%;
  margin: 0 auto;
}
.main_footer_item {
  overflow: hidden;
  /* background-color: royalblue; */
  position: relative;
}
.main_footer_item a{
    position: absolute;
    background: #009944d4;
    color: #fff;
    display: block;
    padding: 15px 30px;
    bottom: 0;
    right: 15px;
}
.main_footer_item > img {
  width: 100%;
  height: 100%;
  text-align: center;
  transition: all 0.5s;
}
.main_footer_item > img:hover{
    opacity: 0.8;
}
.pro_noise{
    position: relative;
    width: 80%;
    margin: 0 auto;
}
.pro_noise > div{
    position: absolute;
    right: 0;
    max-width: 60%;
}
.main_product_t {
  margin-top: 240px;
}
.product_noise {
  width: 40%;
  /* background-color: red; */
  float: left;
  display: flex;
  margin-bottom: 10px;
}
.product_noise_img {
  width: 12%;
}
.product_noise_txt {
  float: left;
  background-color: teal;
  width: 88%;
}
.product_noise_txt_span {
  text-align: left;
  display: block;
  color: white;
  font-size: 14px;
}
.product_noise_txt_span.tit{
    font-weight: bold;
    font-size: 16px;
}

.main {
  width: 100%;
  height: 100%;
  /* background-color: teal; */
}
.main_header {
  width: 25%;
  margin: 0 auto;
}
.main_header_txt > span {
  display: block;
  margin: 0 auto;
  text-align: center;
  width: 100%;
}
.main_txt1 {
  font-size: 40px;
  color: #0168b7;
  display: block;
}
.main_txt2 {
  font-size: 14px;
  color: #868585;
  display: block;
}
.main_header_img {
  /* background-color: brown; */
  margin: 0 auto;
  width: 30%;
  text-align: center;
  display: block;
  margin-top: -180px;
}
.main_xq {
  width: 80%;
  height: 100%;
  margin: 0 auto;
}
.main_xq > div {
  display: block;
}
.main_item_txt > span {
  display: block;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.main_item {
  width: 25%;
  /* background-color: tan; */
  margin-bottom: 60px;
}
.main_item_img {
  margin-bottom: 10px;
}
.main_item:hover {
  background-color: #ffffff;
  box-shadow: 0px 10px 15px #888888;
}
.main_product {
  width: 100%;
  height: 1000px;
  background: url("../../static/img/index_bj2.png");
  text-align: center;
  background-size: cover;
}
.main_product_txt > div > div {
  display: block;
  margin: 0 auto;
  /* background-color: thistle; */
  position: relative;
  top: 50%; /*偏移*/
  padding-bottom: 20px;
  overflow: hidden;
}
.main_product_txt > div > div > span {
  display: block;
  /* text-align:center; */
}
.product1 {
  font-size: 40px;
  color: white;
  /* text-align: center; */
  width: 100%;
  /* text-align: center; */
}
.product2 {
  font-size: 20px;
  color: white;
  width: 100%;
  /* text-align: center; */
}
.product3 {
  font-size: 16px;
  color: white;
  /* text-align: center; */
}
@media screen and (max-width: 992px) {
  .main_product {
    height: 600px;
  }
  .main_product_t {
    margin-top: -10%;
    margin-left: 40%;
  }
  .main_product_t > .text-left > button {
    float: right;
    margin-right: 10%;
  }
}
@media screen and (max-width: 768px) {
    .main_product{
        height: 730px;
        margin-bottom: 20px;
        background: url("../../static/img/mb_index_bj2.jpg") no-repeat center;
        background-size: cover;
    }
    .pro_noise{
        width: 100%;
        /* background: rgba(0,0,0,0.5); */
    }
    .pro_noise > div{
        max-width: 100%;
        top: 100px;
        padding: 0 10px;
    }
    .main_product_txt > div > div{
        padding-bottom: 20px;
    }
  .main_product_t {
    margin-left: 0;
    line-height: 30px;
  }
  .product1 {
    font-size: 20px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
  .product2 {
    font-size: 12px;
  }
  .product3 {
    font-size: 15px;
  }
  .product_noise {
    font-size: 15px;
    width: 100%!important;
  }
  .main_product_t > .text-left > button {
    float: right;
    margin-right: 0;
    width: 100%;
  }
  .main_xq {
    width: 100%;
  }
  .main_item {
    margin-bottom: 30px;
  }
  .main_item_txt > span {
    font-size: 16px;
  }
  .main_item_txt_3 {
    font-size: 16px;
    text-transform: uppercase;
  }
  .main_header_txt > span {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .main_header_txt > span:last-child {
    font-size: 16px;
    margin-bottom: 0;
  }
  .main_product_txt {
    text-align: left;
    padding-right: 15px;
  }
  .main_footer {
    width: 100%;
  }
  .product_noise > div > img {
    display: block;
  }
  .product_noise > div:last-child {
    padding: 0 0 0 5px;
    width: 100%!important;
  }
  .main_footer_txt1 {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .main_footer_txt4,
  .main_footer_txt5 {
    font-size: 14px;
  }
  .main_footer_btn {
    width: 100%;
  }
}
@media screen and (max-width: 576px) {
  .main_product_t {
    margin-left: 0;
    line-height: 22px;
  }
  .main_item {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media screen and (max-width:400px){
    .main_product{
        height: 780px;
    }
}
</style>
<script>
import myfooter from "./zzj/footer_ESP";
import myheader from "./zzj/header_index_ESP";
import WOW from "wowjs";
export default {
  data() {
    return {
      about: false,
      bannerHeight: "",
      bannerImg: [],
      product: [],
      scrollFlag: false
    };
  },
  components: {
    myfooter: myfooter,
    myheader:myheader
  },
  methods: {
    imgLoad() {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight["0"].height;
        console.log(this.$refs.bannerHeight["0"].height);
      });
    },
    enter() {
      this.about = true;
    },
    leave() {
      this.about = false;
    },
    handleScroll() {
      let _this = this;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop)
      if (scrollTop) {
        _this.scrollFlag = true;
      } else {
        _this.scrollFlag = false;
      }
    },
     SeeMore1(){
      this.$router.push(
        {
          path:'/about_ESP2',
          query:{id:51}
        }
      )
    },
     SeeMore2(){
      this.$router.push(
        {
          path:'/about_ESP'
        }
      )
    },
    SeeMoreImg(){
      this.$router.push(
        {
          path:'/about_ESP1'
        }
      )
    },
    // ESP() {
    //   this.$router.push({ path: "/ESP" });
    // },
    // EN() {
    //   this.$router.go(0);
    // }
  },
  mounted() {
    window.addEventListener(
      "resize",
      () => {
        this.bannerHeight = this.$refs.bannerHeight["0"].height;
        this.imgLoad();
      },
      false
    );
    window.addEventListener(
      "load",
      function() {
        let wow = new WOW.WOW({
          boxClass: "wow",
          animateClass: "animated",
          mobile: true,
          live: true
        });
        wow.init();
      },
      false
    );
    window.addEventListener("scroll", this.handleScroll);
  },
  created() {
    this.axios
      .get("/api/banner/index?categoryID=14&language=1")
      .then(res => {
        this.bannerImg = res.data;
        console.log(this.bannerImg);
      })
      .catch(err => {
        console.log(err);
      });
    this.axios
      .get("/api/product/index?langName=2")
      .then(res => {
        this.product = res.data;
        console.log(this.product);
      })
      .catch(err => {
        console.log(err);
      });
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/index_ESP.vue